import { createContext, useContext } from 'react';

/**
 * Mirrors API `canCreateWorkspaceResources`: false for invite-only roster members.
 * When false, hide create/add/new affordances across the app.
 */
export const WorkspaceAddsContext = createContext(true);

export function useWorkspaceAdds() {
  return useContext(WorkspaceAddsContext);
}
